/**
 * The v1 data model, transcribed from spec §4.
 *
 * These are the wire/domain shapes shared by client and server. Persistence
 * shapes arrive with the Drizzle schema in UP-002 and must agree with these.
 */
/**
 * The closed vocabularies are `const` arrays first and types second, because
 * the database has to enforce the same sets and a CHECK constraint cannot read
 * a TypeScript union. One declaration, two consumers.
 */
export const DIFFICULTIES = ['trivial', 'easy', 'medium', 'hard', 'brutal'];
export const PERIODS = ['day', 'week', 'month'];
export const ACTIVITY_TYPES = ['recurring', 'one-time'];
/**
 * The split that is the entire payload of the four-week baseline: same
 * shortfall, opposite fixes (spec §6.3).
 */
export const REFUSAL_REASONS = ['busy', 'dont-want-to'];
//# sourceMappingURL=domain.js.map